module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projects),
      expression: "projects"
    }],
    staticClass: "info-page-wrapper"
  }, [_c('Info', {
    attrs: {
      "info": _vm.info
    }
  })], 1), _c('header', {
    class: {
      "show--info": _vm.showInfo, "translucent--bg": (_vm.projectView || _vm.currentView), "mobile-grey-slide": (_vm.mobileGreySlide && _vm.st <= 0)
    }
  }, [_c('div', {
    staticClass: "bar",
    on: {
      "mouseenter": function($event) {
        _vm.showMenu = true
      },
      "mouseleave": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "intro"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.projects),
      expression: "!projects"
    }],
    staticClass: "bar",
    staticStyle: {
      "z-index": "51",
      "background": "white !important"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Matthieu Lavanchy")])])]), _c('div', {
    staticClass: "bar",
    class: {
      'show--title': _vm.titleVisible, 'hidden--title': !_vm.titleVisible
    }
  }, [_c('span', {
    staticClass: "serif",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _c('transition', {
    attrs: {
      "name": _vm.infoTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.showMenu && !_vm.projectViewMobile) || (_vm.showInfo && !_vm.projectViewMobile)),
      expression: "(showMenu && !projectViewMobile) || (showInfo && !projectViewMobile)"
    }],
    staticClass: "bar"
  }, [_c('navv', {
    attrs: {
      "type": "top",
      "visible": true,
      "showInfo": _vm.showInfo
    }
  })], 1)])], 1)]), _c('div', {
    staticClass: "projects",
    class: _vm.classes
  }, [_c('transition', {
    attrs: {
      "name": "intro"
    }
  }, [(_vm.projects) ? _c('div', {
    ref: "scrollbody",
    staticClass: "main"
  }, [_c('div', {
    ref: "current",
    attrs: {
      "id": "current"
    }
  }, [_c('current', {
    attrs: {
      "current": _vm.currentData
    }
  })], 1), _c('div', {
    ref: "projects",
    staticClass: "thumbs",
    attrs: {
      "id": "projects"
    }
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('div', [_c('a', {
      style: ('background-image: url(' + _vm.thumb(project) + ')'),
      attrs: {
        "data-imgsize": _vm.thumbSize
      },
      on: {
        "click": function($event) {
          _vm.open(index)
        },
        "mouseenter": function($event) {
          _vm.thumbHover(project.data.title)
        },
        "mouseleave": function($event) {
          _vm.hideTitle(200)
        }
      }
    })])
  })), _c('div', {
    ref: "viewer",
    attrs: {
      "id": "viewer"
    },
    on: {
      "click": _vm.viewerClick
    }
  }, [_c('transition-group', {
    attrs: {
      "name": _vm.transition
    }
  }, _vm._l((_vm.projects), function(project, index) {
    return (index === _vm.current) ? _c('project', {
      key: index,
      attrs: {
        "title": _vm.projectView ? _vm.html(project.data.title) : '',
        "current": _vm.currentSlide,
        "slides": project.data.slides,
        "preload": _vm.projects[_vm.nextIndex].data.slides,
        "transition": _vm.transition
      },
      on: {
        "imgHover": function($event) {
          _vm.showTitle(project.data.title, true)
        },
        "imgLeave": _vm.hideTitle
      }
    }) : _vm._e()
  }))], 1)]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5150ec39","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects.vue
// module id = 150
// module chunks = 1